import Axios from "axios";
import React, { useMemo, useState } from "react";
import styled from "styled-components";
import { useRequest } from "../../fetchboi/hooks";
import Layout from "../../components/Layout";
import { Col, Row } from "rsuite";
import DaySelector from "./DaySelector";
import { motion } from "framer-motion";
import Activities from "./Activities";
import Icon from "../../components/Icon";
import Button from "../../components/Button";
import { useCongress } from '../../congress/hooks'
import moment from 'moment-timezone'
import { apiURL } from '../../config'

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.05,
    },
  },
  hover: {
    y: 0,
    opacity: 1,
    scale: 1.05
  }
};

export default function Program() {
  const { congress } = useCongress()

  const axios = useMemo(() => Axios.create({
    baseURL: apiURL,
    params: {
      CongressSlug: congress.Slug
    }
  }), [congress.Slug])

  const [selected, setSelected] = useState(0);
  const [activities, loading] = useRequest({
    url: "/activities?include=Speakers",
  });

  const downloadProgram = async () => {
    try {
      const response = await axios.post("/activities/pdf", 
        {
          CongressName: congress.Name,
          CongressColor: congress.PrimaryColor,
          CongressSlug: congress.Slug,
        },
        {
          responseType: 'blob'
        }
      );
      
      const contentDisposition = response.headers['content-disposition'];
      const fileName = contentDisposition
        ? contentDisposition.split('filename=')[1].replace(/"/g, '')
        : `activities_${congress.Slug}.pdf`;

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      
      window.URL.revokeObjectURL(url);
      link.remove();
    } catch (error) {
      console.error("Error descargando el PDF:", error);
    }
  }

  const days = useMemo(
    () =>
      [
        ...new Set(
          activities?.map((it) => moment(it.StartsAt).startOf("day").toString())
        ),
      ].map((it) => moment(it)),
    [activities]
  );

  return (
    <Layout.Container>
      <Container>
        <Layout.Title>
          <TittleContainer>
           <div> Programa </div>
           {activities && activities.length > 0 && (
            <Button 
            color={congress.PrimaryColor} 
            onClick={downloadProgram}
            style={{ padding: 0 }}
            rounded
            >
              <p style={{ fontSize: 14, padding: 0}}>Descargar Programa</p> 
            </Button>
           )}

          </TittleContainer>
          </Layout.Title>
        <Layout.Loader loading={loading} />
        {activities && activities.length > 0 && (
          <Row gutter={32}>
            <Col md={8}>
              <motion.div
                variants={containerVariants}
                initial="hidden"
                animate="visible"
              >
                <DaySelector
                  days={days}
                  selected={selected}
                  onSelect={setSelected}
                />
              </motion.div>
            </Col>
            <Col md={16}>
              <Activities activities={activities} day={days[selected]} />
            </Col>
          </Row>
        )}

        {!activities ||
          (activities.length === 0 && (
            <Row gutter={32}>
              <motion.div
                variants={containerVariants}
                initial="hidden"
                animate="visible"
              >
                <Col md={8}>
                  <Icon icon="megaphone" size={16} />
                  <span style={{ marginLeft: 4 }}>
                    ¡Pronto publicaremos la información!
                  </span>
                </Col>
              </motion.div>
            </Row>
          ))}
      </Container>
    </Layout.Container>
  );
}

const Container = styled.div``;

const TittleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;